// src/context/ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

const KEY = "th-theme";
const systemDark = () => window.matchMedia("(prefers-color-scheme: dark)").matches;
const saved = () => { try { return localStorage.getItem(KEY); } catch { return null; } };

export default function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => { const s = saved(); return s ? s === "dark" : systemDark(); });

  // apply the theme to <html>; also tell the browser (address bar / mobile chrome)
  useEffect(() => {
    document.documentElement.dataset.theme = dark ? "dark" : "light";
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", dark ? "#0f0f14" : "#ffffff");
  }, [dark]);

  // until the visitor picks a theme themselves, follow the device setting live
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e) => { if (!saved()) setDark(e.matches); };
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  // only an explicit toggle is remembered (the old code saved the device default too, which froze it)
  const toggle = () => {
    const next = !dark;
    try { localStorage.setItem(KEY, next ? "dark" : "light"); } catch { /* private mode */ }
    setDark(next);
  };

  return <ThemeContext.Provider value={{ dark, toggle }}>{children}</ThemeContext.Provider>;
}
